import React from 'react';

const CheckboxField = ({ input, label, type, description, disabled }) => (
  <label className="btn">
    <input type={type} disabled={disabled} {...input} />
    <i className="fa fa-square-o fa-2x" />
    <i className="fa fa-check-square-o fa-2x" />
    <span className="input-description"> {description}</span>
  </label>
);
export default CheckboxField;



// WEBPACK FOOTER //
// ./src/components/form/CheckboxField.js